import store from '@/store';

interface Iparams {    
    dataKey : string;
    primerykey : string;
}

class DatahelperSingleton {
    //饿汉式单例

    //声明
    public dataKey : string;
    public primerykey : string;
    // 静态子段
    private static instance: DatahelperSingleton = new DatahelperSingleton();

    //构造函数 参数可变
    constructor(params?:Iparams){
        this.dataKey = params && params.dataKey!=null && params.dataKey.trim()!="" ? params.dataKey:'';
        this.primerykey = params && params.primerykey!=null && params.primerykey.trim()!="" ? params.primerykey:'';
    }

    //3.提供一个公有的静态方法，返回实例对象
    static getInstance(): DatahelperSingleton {
        return DatahelperSingleton.instance;
    }

    //根据dataKey读取localstorage对于key的value
    readData(dataKey: any): any{

        if(store.state.VTVersionColName === dataKey)
        {
            if(store.state.VTVersionCol === localStorage.getItem("VTVersionCol"))
            {
                return this.readVersionData(dataKey);
            }
            else
            {
                localStorage.setItem("VTVersionCol",store.state.VTVersionCol);
                return [];
            }
        }
        else if(store.state.VTVersionCol1Name === dataKey){
            if(store.state.VTVersionCol1 === localStorage.getItem("VTVersionCol1"))
            {
                return this.readVersionData(dataKey);
            }
            else
            {
                localStorage.setItem("VTVersionCol1",store.state.VTVersionCol1);
                return [];
            }
        }
        else if(store.state.VTVersionCol2Name === dataKey){
            if(store.state.VTVersionCol2 === localStorage.getItem("VTVersionCol2"))
            {
                return this.readVersionData(dataKey);
            }
            else
            {
                localStorage.setItem("VTVersionCol2",store.state.VTVersionCol2);
                return [];
            }
        }
        else{
           return this.readVersionData(dataKey);
        }
    }

    //存取
    savaData(dataKey: any,arrData: Array<object>): void{
        //数组转json
        const str: string = JSON.stringify(arrData);
        //保存到本地
        localStorage.setItem(dataKey,str);
    }

    readVersionData(dataKey: any): any{
         //从本地数据中获取数据
         const strData: string | null = localStorage.getItem(dataKey);
         //字符串转数组
         let arrData: any = [];
         if(strData!=null){
             arrData = JSON.parse(strData);
         }
         return arrData; 
    }
}

export default DatahelperSingleton;